import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=f3785d4e&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3785d4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3785d4e')) {
      api.createRecord('f3785d4e', component.options)
    } else {
      api.reload('f3785d4e', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=f3785d4e&scoped=true&", function () {
      api.rerender('f3785d4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bopLGgPRloRQ/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports